var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLeftArrowBlackCircle = function SvgLeftArrowBlackCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    x: 44,
    y: 44,
    fill: "#000",
    rx: 22,
    transform: "rotate(-180 44 44)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M20.088 26.784a.562.562 0 0 0-.095-.799l-1.77-1.376-2.326-2.043h14.525c.32 0 .578-.254.578-.568a.573.573 0 0 0-.578-.569h-14.38L20.077 18a.562.562 0 0 0 .06-.802.584.584 0 0 0-.815-.058l-5.265 4.476a.565.565 0 0 0-.2.426v.004c0 .162.07.316.193.424l3.43 3.01 1.797 1.398c.25.195.613.153.811-.093Z"
  })));
};
export default SvgLeftArrowBlackCircle;